<template>
  <b-modal
    id="create-denounce"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="createDenounce"
    @shown="loadOptions"
    @hidden="clearOptions"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>

    <template v-slot:default>
      <slot name="description"></slot>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <form
        action=""
        method="POST"
        class="mt-4 default-form"
        @submit.prevent="submit"
        v-if="options.length > 0"
      >
        <ul class="d-flex flex-wrap">
          <li
            class="col-12 col-lg-6 px-2 mb-2"
            v-for="option in options"
            :key="option.id"
          >
            <div class="styled-radio-as-input d-flex h-100">
              <input
                type="radio"
                :id="`radio-${option.id}`"
                name="option"
                v-model="denounce.option"
                :value="option.id"
              />
              <label
                class="w-100 d-flex align-items-center"
                :for="`radio-${option.id}`"
              >
                {{ option.label }}
              </label>
            </div>
          </li>
        </ul>

        <div class="mt-3 form-group">
          <DefaultTextarea
            v-model="denounce.description"
            label="Caso deseje adicionar mais informações"
          />
        </div>

        <div class="mt-3 text-center">
          <Button
            type="submit"
            class="btn-primary"
            :loading="loader"
            :disabled="$v.$invalid"
          >
            Realizar denúncia
          </Button>
        </div>
      </form>
      <div
        class="text-center"
        v-else
      >
        <Loader
          color="color2"
          size="big"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>

import DenouncesService from '@/modules/denounces/services/denounces-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { required } from 'vuelidate/lib/validators'
import { parseErrorResponseToArray } from '@/utils'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button.vue'
import DefaultTextarea from '@/components/common/Textarea/DefaultTextarea.vue'
import Loader from '@/components/common/Loader/Loader.vue'

export default {
  name: 'DenounceModal',
  props: ['title', 'type', 'target'],
  components: {
    AlertWraper,
    Button,
    DefaultTextarea,
    Loader
  },
  data () {
    return {
      options: [],
      denounce: {
        option: null,
        description: null
      },
      loader: false,
      errors: null
    }
  },
  validations () {
    return {
      denounce: {
        option: { required }
      }
    }
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true
      }
    }
  },
  methods: {
    loadOptions () {
      this.getOptions()
      this.errors = null
    },
    clearOptions () {
      this.options = []
      this.errors = null
    },
    async getOptions () {
      try {
        const options = await DenouncesService.getOptions(this.type)
        this.options = options
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
    },
    async submit () {
      this.loader = true
      try {
        const data = {
          type: this.type,
          name: this.denounce.option,
          description: this.denounce.description,
          target: this.target
        }
        const denounce = await DenouncesService.create(data)
        this.$bvModal.hide('create-denounce')
        const notification = {
          notification: {
            type: 'success',
            content: 'Denúncia criada com sucesso, agradecemos sua colaboração'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('denounce-created', denounce)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .modal-title {
    font-size: $font_size_medium;
  }

  ::v-deep {
    .styled-radio-as-input label {
      margin-bottom: 0;
    }
  }
</style>
